import { render } from "./Report.vue?vue&type=template&id=9bb7c3ce"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"

import "./Report.vue?vue&type=style&index=0&id=9bb7c3ce&lang=css"
script.render = render

export default script